import * as React from "react";
import { Box, Button, Typography } from "../mui";
import Modal from "./Modal";

/**
 * ConfirmDialog
 * Generic confirmation modal for destructive / important actions (e.g. delete).
 * UI-only; parent provides the actual onConfirm behavior.
 */
export default function ConfirmDialog({
  open,
  title = "Confirm",
  message = "Are you sure you want to continue?",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  onConfirm,
  onClose
}) {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  const actions = (
    <>
      <Button variant="outlined" onClick={onClose}>
        {cancelLabel}
      </Button>
      <Button variant="contained" color="primary" onClick={handleConfirm}>
        {confirmLabel}
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      actions={actions}
      maxWidth="xs"
    >
      <Box style={{ marginTop: 8 }}>
        <Typography variant="body2">
          {message}
        </Typography>
      </Box>
    </Modal>
  );
}
